import React from 'react';

import GiftCardForm from '../components/forms/giftCards/GiftCardForm';

import { DrumallProductProvider, useSelectedProducts } from './DrumallProductProvider';

const DrumallProductForm = () => {
    const { products } = useSelectedProducts();
    return <GiftCardForm {...products} />;
};

export default () => (
    <DrumallProductProvider>
        <DrumallProductForm />
    </DrumallProductProvider>
);
